var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmSlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4659",
    "data-name": "Group 4659",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.096,
    height: 14.612,
    viewBox: "0 0 19.096 14.612",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2700",
    "data-name": "Rectangle 2700",
    width: 19.096,
    height: 14.612,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2415",
    "data-name": "Path 2415",
    d: "M224,304.616v2.374a6.049,6.049,0,0,0-7.039.087,1.045,1.045,0,1,1-1.178-1.727,8.471,8.471,0,0,1,4.762-1.492,8.251,8.251,0,0,1,3.455.758",
    transform: "translate(-211 -297.754)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2416",
    "data-name": "Path 2416",
    d: "M114.663,151.078a11.035,11.035,0,0,1,3.455.549V153.8a9.159,9.159,0,0,0-3.455-.674,9.528,9.528,0,0,0-5.79,2.01,1,1,0,0,1-1.226-1.576,11.212,11.212,0,0,1,7.016-2.48",
    transform: "translate(-105.115 -148.043)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2417",
    "data-name": "Path 2417",
    d: "M802.472,259.161a1,1,0,0,1-.542.281V257.33c.163.118.315.233.455.345a1,1,0,0,1,.087,1.486",
    transform: "translate(-785.821 -252.161)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    "data-name": "Path 2418",
    d: "M18.815,4.822l-.009.009a.97.97,0,0,1-1.309.06,12.475,12.475,0,0,0-1.387-1V2.855a1.545,1.545,0,0,0-1.543-1.543h-.019a1.546,1.546,0,0,0-1.5,1.2A12.428,12.428,0,0,0,1.6,4.89.97.97,0,0,1,.29,4.83L.281,4.822A.968.968,0,0,1,.332,3.409a14.162,14.162,0,0,1,18.432,0,.968.968,0,0,1,.05,1.412",
    transform: "translate(0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    "data-name": "Path 2419",
    d: "M333.07,458.935h0a1.037,1.037,0,0,1-1.216.194,3.011,3.011,0,0,0-2.9,0,1.044,1.044,0,0,1-.975-1.846,4.914,4.914,0,0,1,4.853,0,1.044,1.044,0,0,1,.241,1.652",
    transform: "translate(-320.854 -447.469)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2420",
    "data-name": "Path 2420",
    d: "M419.914,613.128a1.159,1.159,0,1,1-1.159-1.159,1.159,1.159,0,0,1,1.159,1.159",
    transform: "translate(-409.207 -599.675)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M680.153,632.424a.931.931,0,1,1-.931-.931.931.931,0,0,1,.931.931",
    transform: "translate(-664.666 -618.808)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M677.838,104.472h-.019a.95.95,0,0,1-.95-.95v-7.7a.95.95,0,0,1,.95-.95h.019a.95.95,0,0,1,.95.95v7.7a.95.95,0,0,1-.95.95",
    transform: "translate(-663.272 -92.964)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmSlow);
export default __webpack_public_path__ + "static/media/sm-slow.2c6908a7.svg";
export { ForwardRef as ReactComponent };